define('router',[
	// Application.
	"app",
	"jquery",
	"underscore",
	"backbone",
],

function(app, $, _, Backbone) {
	// Defining the application router, you can attach sub routers here.
	var Router = Backbone.Router.extend({

		routes: {
			"": "index",
			'*def': 'index',
		},

		initialize: function() {
			// console.log("override router initialized");
			_.bindAll(this, 'index');
		},

		index: function() {
			// console.log("override router fired up");
			var currentPath = window.location.pathname;

			switch (currentPath) {
				// manual routes can be added as cases here
				default: break;
			}
		},
	});

	return Router;

});
